/**
 * 조회 캐시 기본값 — 전역 설정(QueryProvider)이 캐시를 끄고 있어
 * (staleTime 0 · gcTime 0 · refetchOnMount) 컴포넌트가 마운트될 때마다 같은 조회가 다시 나간다.
 * 한 화면에 조회가 많은 곳 — 특히 PDF 빌더 — 에서 비용이 크므로, 편집 중에 바뀌지 않는
 * 데이터에만 캐시를 준다 (일감 #196).
 *
 * 캐시를 주는 조회는 반드시 바꾸는 쪽(mutation)에 invalidateQueries 가 걸려 있어야 한다.
 * 없으면 저장해도 화면이 갱신되지 않는다.
 */

/** 분석이 끝나면 불변인 리포트 결과 */
export const ANALYSIS_CACHE = {
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
  refetchOnMount: false,
} as const

/** 팀 설정·메트릭 정의 — 리포트를 편집하는 동안 바뀌지 않는다 */
export const TEAM_SETTING_CACHE = ANALYSIS_CACHE
